(function ($) {
    var find = {};

    find.clan_render = function () {
        var $item = $(this);
        var clanIconPath;

        var CLAN_ICON_SELECTOR = '[data-field="clan-icon"] span';
        var $clanIcon = $item.find(CLAN_ICON_SELECTOR).first();
        clanIconPath = 'portal/img/svg-icons/clans/' + (($item.data('my-clan') == "True") ? 'myclan' : 'clan') + '.svg';
        $clanIcon.renderListBoxIcon(window.STATIC_URL + clanIconPath, gettext('Clan'), 'js-svg-autosize-from-height');
    };


    window.find = find;

})(jQuery);
